<template>
    <div>                             
        <div class="task-kanban-holder">
            <div class="to-do-holder">
                <h4 class="text-center">To Do</h4>
               <draggable 
                group="id" 
                :list="toDoList"
                :id="1"
               :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in toDoList" >
                <div class="card-holder" @click="showModalForEdit(taskListing)">
                    <div class="flex justify-between items-center">
                        <h6 class="mb-4"><b>{{taskListing.name}}</b></h6>
                        <vs-dropdown v-if="taskListing.checkDeletePermission">
                            <vs-button class="btn-drop" type="flat" color="danger" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                            <vs-dropdown-menu>
                         <vs-dropdown-item  @click="haldleDelete(taskListing.id)">Delete</vs-dropdown-item>
                            
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <!-- <p class="name">{{userInfo.first_name}}</p> -->
                        <p class="name" v-if="taskListing.project !== null">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="task-cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                  
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2" v-if="taskListing.due_date">
                                <feather-icon icon="ClockIcon" />
                                <span v-if="taskListing.due_date">{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority!==null && taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority!==null && taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority!==null && taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>

                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                        <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                          <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                        </vs-tooltip>
                        <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                          <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                        </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
                 
            </div>

           <div class="progress-holder">
                <h4 class="text-center">In Progress</h4>
            
               <draggable :list="inProgressList"  group="id"
               :id="2"
                :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in inProgressList" >

                <div class="card-holder"  @click="showModalForEdit(taskListing)">
                    <div class="flex justify-between items-center">
                      <h6 class="mb-4"><b>{{taskListing.name}}</b></h6>
                       <vs-dropdown v-if="taskListing.checkDeletePermission">
                            <vs-button class="btn-drop" type="flat" color="danger" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                            <vs-dropdown-menu>
                         <vs-dropdown-item  @click="haldleDelete(taskListing.id)">Delete</vs-dropdown-item>
                            
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <!-- <p class="name">{{userInfo.first_name}}</p> -->
                        <p v-if="taskListing.project" class="name">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="task-cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2">
                                <feather-icon icon="ClockIcon" />
                                <span  v-if="taskListing.due_date">{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>

                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
                 
            </div>

           <div class="done-holder">
                <h4 class="text-center">Done</h4>

            
               <draggable :list="doneList"  group="id"
               :id="3"
               :move="checkMove"  class="w-full py-2 cursor-move">
                 
                <div :key="taskListing.id" v-for="taskListing in doneList" >

                <div  class="card-holder" @click="showModalForEdit(taskListing)">
                    <div class="flex justify-between items-center">
                        <h6 class="mb-4"><b>{{taskListing.name}}</b></h6>
                         <vs-dropdown v-if="taskListing.checkDeletePermission">
                            <vs-button class="btn-drop" type="flat" color="danger" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                            <vs-dropdown-menu>
                         <vs-dropdown-item  @click="haldleDelete(taskListing.id)">Delete</vs-dropdown-item>
                            
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <p class="content mb-4">{{taskListing.details}}</p>
                    <div class="name-badge-holder">
                        <!-- <p class="name">{{userInfo.first_name}}</p> -->
                        <p v-if="taskListing.project" class="name">{{taskListing.project.name}}</p>
                        <span v-if="taskListing.projectStatusTag" class="task-cstm-badge yellow-badge">
                            {{taskListing.projectStatusTag.name}}
                        </span>
                    </div>
                    <div class="kanban-icon-holder">
                        <div>
                            <div class="mr-2">
                                <feather-icon icon="ClockIcon" />
                                <span  v-if="taskListing.due_date">{{taskListing.due_date.split(' ')[0]}}</span>
                            </div>

                            <!-- <div class="mr-2">
                                <feather-icon icon="LinkIcon" />
                                <span>1</span>
                            </div> -->
                        </div>
                        
                        <div v-if="taskListing.task_priority.id === 2" class="mediumPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 1" class="highPriority">
                            <feather-icon icon="ArrowUpIcon" />
                        </div>
                        <div v-if="taskListing.task_priority.id === 3" >
                            <feather-icon color="success" icon="ArrowUpIcon" />
                        </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Responsible: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientResponsiblePerson.concat(taskListing.userResponsiblePerson)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                    <div class="flex flex-wrap my-2">
                      <label class="vs-input--label mr-5"><b>Participants: </b></label>
                      <div class="cstm-img-holder" v-for="(pic,index2) in taskListing.clientParticipant.concat(taskListing.userParticipant)" :key="index2">
                          <vs-tooltip v-if="pic.picture !== ''" :text="pic.first_name+' '+pic.last_name">
                            <img :src="pic.picture" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                          <vs-tooltip v-else :text="pic.first_name+' '+pic.last_name">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                          </vs-tooltip>
                      </div>
                    </div>
                </div>
                </div>
                </draggable>
            </div>
        </div>
    </div>
</template>
<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { taskUpdate, taskDelete } from '@/api/task-project.js'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import { TaskProject } from '../mixins/task-project.js'

export default {
  name: 'kanban',
  props: ['liveData'],
  data () {
    return {
      kanbanData: this.liveData,
      configdateTimePicker1: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: false
      },
      toDoList: [], //status->1
      inProgressList: [], //staus->2
      doneList: [], //status->
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      selectedTab: null
    }
  },
  components: {
    'v-select': vSelect,
    draggable
  },
  mixins: [TaskProject, PermissionMiddleware],
  computed: {
    buttonActive () {
      if (this.responsibleData.length !== 0 && this.taskData.name !== '' && this.taskData.task_priority_id !== '' && this.taskData.due_date !== '') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    liveData () {
      this.kanbanData = this.liveData
      this.filterKanbanData()
    }
  },
  mounted () {
    this.filterKanbanData()
    this.userList = this.$store.getters.getGlobalUserList
    this.showButtonUser = this.$store.getters.getShowButtonUser
    this.clientList = this.$store.getters.getGlobalClientList
    this.showButtonClient = this.$store.getters.getShowButtonClient
    this.priority = this.$store.getters.getGlobalPriorityList
    this.tagsList = this.$store.getters.getGlobalTagList
    this.tag_meta = this.$store.getters.getTagMeta
    this.parentTaskData = this.$store.getters.getGlobalParentList
    this.sub_meta = this.$store.getters.getSubMeta
    this.ListOfTaskUpdate = this.$store.getters.getListOfTaskUpdate
    this.meta_template = this.$store.getters.getMetaTemplate
    this.ListOfLiveTaskUpdate = this.$store.getters.getListOfLiveTaskUpdate
    this.meta_task = this.$store.getters.getMetaTask
    this.ListOfProject = this.$store.getters.getListOfProject
    this.meta = this.$store.getters.getMeta
    this.leadList = this.$store.getters.getGlobalLeadList
    this.leadMeta = this.$store.getters.getLeadMeta
  },
  methods: {
    filterKanbanData () {
      this.toDoList = this.kanbanData.filter(ele => {
        return ele.status.id === 1
      })
      this.inProgressList = this.kanbanData.filter(ele => {
        return ele.status.id === 2
      })
      this.doneList = this.kanbanData.filter(ele => {
        return ele.status.id === 3
      })
    },
    async haldleDelete (id) {
      const deleting_id = id
      const payload = {
        deleteFields: [deleting_id]
      }
      try {
        await taskDelete(localStorage.getItem('customer_id'), payload)
        
        const table = this.kanbanData
        for (const delete_id_itr of [deleting_id]) {
          for (let i = 0; i < table.length; i++) {
            if (delete_id_itr === table[i].id) {
              table.splice(i, 1)
            }
          }
        }
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.kanbanData = table
        this.filterKanbanData()
        this.successPopupMessage('Task Deleted Successfully')
      } catch (error) {
        this.warningPopupMessage(error.data.message)
      }
    },
    openModalSectionLiveFromKanban (params) {
      this.$emit('openModalSectionLiveFromKanban', params)
    },
    showModalForEdit (params) {
      this.openModalSectionLiveFromKanban(params)
    },
    checkMove (evt) {
      if (evt.draggedContext.element.checkEditPermission === true) {
        const id = evt.draggedContext.element.id
        const changestatusTo = evt.to.id
        const payload = {
          updateField: {
            task_status_id: changestatusTo
          }
        }
        if (evt.from.id !== evt.to.id) {
          this.kanbanStatusUpdate(id, payload)
        }
      } else {
        this.warningPopupMessage('You don\'t have edit permission')
      }
    },
    async kanbanStatusUpdate (id, payload) {
      try {
        const { data } = await taskUpdate(localStorage.getItem('customer_id'), id, payload)
        data.data.task.status_list = this.priority
        data.data.task.live_status_list = this.options
        const afterUpdate = [data.data.task]
        this.kanbanData = this.kanbanData.map(obj => afterUpdate.find(o => o.id === obj.id) || obj)
        this.filterKanbanData()
        this.successPopupMessage('Task status changed')
      } catch (apiError) {
        //
      }
    }

  }
}
</script>

<style>
    
</style>